var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ods-radio-group",class:{'ods-radio-group--full-width' : _vm.fullWidth},attrs:{"role":"radiogroup"},on:{"keydown":_vm.handleKeydown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }